import React from "react";

const Columns = (props) => {
  const { children } = props;
  return <div className="columns">{children}</div>;
};

export default Columns;
